import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="page"
export default class extends Controller {
    openDrawer(e) {
        var event = new Event("drawer.open");
        event.url = $(e.target).closest('[data-drawer-url]').attr('data-drawer-url');
        document.dispatchEvent(event);
    }
}
